import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const Link = styled(Text)(({ theme }) => ({
  color: theme.palette.text.blue,
  textDecoration: 'underline',
}));
